import React, { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { unsetAlert } from "../../reducers/alertSlice";
import { useDeviceType } from "src/Utils/useDeviceType";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SnackAlert() {

  const dispatch = useDispatch();
  const alert = useSelector(state => state.alert);
  const { isDesktop } = useDeviceType();

  useEffect(() => {
  },[alert]);

  return (
    <Snackbar
      open={alert?.status}
      autoHideDuration={6000}
      onClose={()=>dispatch(unsetAlert())}
      anchorOrigin={!isDesktop
        ? { vertical: 'bottom', horizontal: 'center' }
        : { vertical: 'bottom', horizontal: 'right' }
      }
      sx={!isDesktop ? { width: '90%', left: '5% !important', right: '5% !important' } : {}}
      >
      <Alert onClose={()=>dispatch(unsetAlert())} severity={alert?.type ? alert?.type : 'info' } sx={{ width: '100%' }}>
        { alert?.msg  }
      </Alert>
    </Snackbar>
  );
}